export function readAudioFile(event, onloadCallback, errorCallback, fileSizeLimitMB = 500) {
    const reader = new FileReader();
    const file = event.target.files[0];
    const filename = file.name;
    reader.onload = (fileData) => {
        const audio = document.createElement('AUDIO');
        const objectUrl = URL.createObjectURL(file);        
        $(audio).on("canplay", function(e){
            debugger;
            const seconds = e.currentTarget.duration;
            window.URL.revokeObjectURL(objectUrl);
            onloadCallback(fileData, filename, seconds);   
        });  
        $(audio).on("error", function(e) {
            window.URL.revokeObjectURL(objectUrl);
            if(errorCallback) {
                errorCallback('An error occurred, unable to process audio file');
            }
        });        
        $(audio).prop('src', objectUrl);
    } 
    const fileSizeMB = file.size/1024/1024;
    if(fileSizeMB > fileSizeLimitMB) {
        if(errorCallback) {
            errorCallback(`The file selected is too big, please upload a file under ${fileSizeLimitMB}MB`);
        }
    }
    else if(/\.(aiff|wav|flac|alac|ogg|mp2|mp3|aac|amr|wma)$/i.test(file.name)) {
        reader.readAsDataURL(file);
    }  
}